<template>
    <div>
        <vs-table noDataText="No data" :data="localData">
        <template slot="thead">
            <vs-th v-if="showCheckboxes" style="width: 60px;">
              <vs-checkbox
                :checked="allCompaniesSelected"
                @change="handleSelectAllCompanies"
              />
            </vs-th>
            <vs-th>Empresa de medios</vs-th>
            <vs-th>Archivos</vs-th>
            <vs-th>Fecha creación</vs-th>
            <vs-th>Fecha de pago</vs-th>
            <vs-th>Periodo</vs-th>
            <vs-th>Moneda</vs-th>
            <vs-th>Monto</vs-th>
            <vs-th style="width: 150px;">Acción</vs-th>
        </template>
      <template slot-scope="{data}">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data" :class="{'text-grey': tr.canceled_at}">
          <vs-td v-if="showCheckboxes">
            <vs-checkbox
              :checked="isCompanySelected(tr.company_id)"
              :disabled="Boolean(tr.canceled_at)"
              @change="handleCompanySelection(tr.company_id)"
            />
          </vs-td>
          <vs-td>
            <div class="flex items-center gap-2">
              <span>{{ tr.company_name }}</span>
              <vx-tooltip v-if="isFinalSecuredRow(tr)" text="ASEGURADO">
                <vs-chip color="#0096f5" class="text-white">ASEGURADO</vs-chip>
              </vx-tooltip>
              <vs-chip v-if="tr.canceled_at" color="#E86B73" class="text-white">Anulada</vs-chip>
            </div>
          </vs-td>
          <vs-td>
            <div class="flex gap-2 items-center" v-if="tr.file">
                <div class="mr-2">
                  <a style="padding-left: 10px;" :href="tr.file" target="_blank">
                    Ver
                  </a>
                </div>
                <div class="flex-1">
                  <vs-button size="small" :disabled="isActionDisabled(tr)" v-if="!tr.is_closed" class="cursor-pointer w-full" color="primary" transparent icon="move_to_inbox" @click="closeOdc(tr)">
                    Cerrar
                  </vs-button>
                  <vs-button size="small" v-else class="cursor-pointer w-full" transparent color="success" icon="check" disabled>
                    Cerrada
                  </vs-button>
                </div>
                <div class="flex-1">
                  <vs-button
                    size="small"
                    class="cursor-pointer w-full"
                    color="primary"
                    :type="tr.email_send_at ? 'border' : 'filled'"
                    icon="send"
                    @click="handleSendEmail(tr)"
                    :disabled="isSendDisabled(tr)"
                  >
                    {{ emailButtonLabel(tr) }}
                  </vs-button>
                </div>
              </div>
            <div class="text-center" v-else-if="canGenerateSecuredOdc(tr)">
              <vs-button
                size="small"
                class="cursor-pointer"
                color="primary"
                type="filled"
                @click="generateSecuredOdc(tr)"
                :disabled="Boolean(tr.canceled_at)"
              >
                Generar ODC
              </vs-button>
            </div>
            <div class="text-center" v-else>
              <span>No hay archivo</span>
            </div>
          </vs-td>
          <vs-td>
            {{ dateFormatter(tr.created_at) }}
          </vs-td>
          <vs-td>
            <!-- {{ dateFormatter(tr.paid_at) }} -->
            <flat-pickr
              v-if="tr.id"
              width="100%"
              :config="configDatePicker"
              v-model="tr.payment_date"
              placeholder="Fecha de pago"
              :disabled="isActionDisabled(tr)"
              @on-close="updatePaidAt(tr.id, $event)"
            />
            <span v-else>-</span>
          </vs-td>
          <vs-td>
            {{dateFormatter(tr.start_period)}} - {{dateFormatter(tr.end_period)}}
          </vs-td>
          <vs-td class="total-currency-column" :id="`total-currency-column-${tr.id}`">
            <vs-select
              :value="tr.currency"
              v-if="tr.id"
              @input="handleCurrencyEdit(tr.id, $event)"
              :disabled="isActionDisabled(tr)"
            >
              <vs-select-item
                v-for="currency in currencies"
                :key="currency.value"
                :value="currency.value"
                :text="currency.text"
              />
              <span slot="no-options">Nada que mostrar.</span>
            </vs-select>
            <span v-else>{{ displayCurrency(tr) }}</span>
          </vs-td>
          <vs-td>
            <vs-input
              v-if="tr.id"
              :value="stringCurrencyFormatter(tr.total_amount)"
              :disabled="isActionDisabled(tr)"
              @input="handleTotalAmountEdit(tr.id, $event)"
            />
            <span v-else>{{ displayAmount(tr) }}</span>
          </vs-td>
          <vs-td>
            <div v-if="tr.file && canUseFullActionRow(tr)" class="flex justify-start gap-2">
              <vs-button
                :color="tr.canceled_at ? 'warning' : 'danger'"
                :title="tr.canceled_at ? 'Recuperar' : 'Anular'"
                :type="tr.canceled_at ? 'filled' : 'border'"
                :icon="tr.canceled_at ? 'restore' : 'not_interested'"
                @click="toggleCancelOdc(tr)"
              />
              <vs-button
                color="primary"
                type="filled"
                title="Reemplazar"
                icon="repeat"
                @click="openReplaceOdcInput(tr)"
                :disabled="Boolean(tr.canceled_at)"
              />
              <input
                type="file"
                :name="`replaceOdcInput-${tr.id}`"
                :id="`replaceOdcInput-${tr.id}`"
                class="hidden"
                @change="handleReplaceOdcUpload"
                accept="application/pdf"
              >
            </div>
            <div v-else-if="canGenerateSecuredOdc(tr)">
              <span class="text-grey">Pendiente de generar</span>
            </div>
            <div v-else>
              <span>-</span>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
import { stringCurrencyFormatter, dateFormatter } from '../../../../utils/strings';
import appConfig from '@/../appConfig.js'
import {Spanish as SpanishLocale} from 'flatpickr/dist/l10n/es.js'
import flatPickr from 'vue-flatpickr-component'
import { currenciesList } from '../../../../utils/misc';
import _ from 'lodash';

export default {
    name: 'company-odc-table',
    props: {
        data: {
            type: Array,
            required: true
        },
      isFinalTable: {
        type: Boolean,
        default: false
      },
        showCheckboxes: {
            type: Boolean,
            default: false
        },
        selectedCompanies: {
            type: Array,
            default: function() {
              return [];
            }
        }
    },
    components: {
      flatPickr
    },
    data() {
        return {
            stringCurrencyFormatter,
            dateFormatter,
            selectedFile: null,
            localData: [],
            configDatePicker: {
              locale: SpanishLocale,
              mode: 'single',
              altInput: true,
              altFormat: 'd/m/Y',
              dateFormat: 'Y-m-d',
              defaultDate: null,
              inline: false
            },
            currencies: currenciesList
        }
    },
    mounted() {
      this.localData = this.normalizeRows(this.data)
    },
    computed: {
      allCompaniesSelected() {
        if (!this.showCheckboxes || !this.localData.length) return false;
        var uniqueCompanyIds = this.getUniqueCompanyIds();
        if (uniqueCompanyIds.length === 0) return false;
        var vm = this;
        return uniqueCompanyIds.every(function(id) {
          return vm.selectedCompanies.indexOf(id) !== -1;
        });
      }
    },
    watch: {
      data: {
        handler() {
          this.localData = this.normalizeRows(this.data)
        },
      }
    },
    methods: {
      parseAmount(value) {
        // El input muestra el valor formateado ("$ 1,234.56"), así que limpiamos
        // el "$", comas y espacios antes de validar/enviar el número.
        if (value === null || value === undefined || value === '') return NaN;
        if (typeof value === 'number') return value;
        return Number(String(value).replace(/[^0-9.-]/g, ''));
      },
      extractErrorStatus(error) {
        return error && error.response ? Number(error.response.status) : null;
      },
      extractPurchaseOrderIdFromError(error) {
        if (!error || !error.response || !error.response.data) {
          return null;
        }

        const responseData = error.response.data;

        if (responseData.purchase_order_id) {
          return responseData.purchase_order_id;
        }

        if (responseData.data && responseData.data.purchase_order_id) {
          return responseData.data.purchase_order_id;
        }

        return null;
      },
      findExistingSecuredPurchaseOrderId(tr) {
        if (!tr) return null;

        const candidates = this.localData.filter((row) => {
          const samePeriod = (!tr.start_period || !row.start_period || tr.start_period === row.start_period)
            && (!tr.end_period || !row.end_period || tr.end_period === row.end_period);
          const rowMonth = Number(row.month);
          const targetMonth = Number(tr.month);
          const sameMonth = rowMonth === targetMonth || rowMonth === 0 || Number.isNaN(rowMonth);

          return Number(row.company_id) === Number(tr.company_id)
            && sameMonth
            && Number(row.year) === Number(tr.year)
            && samePeriod
            && Boolean(row.is_secured_investment)
            && row.id;
        });

        if (!candidates.length) return null;

        const activeCandidate = candidates.find((row) => !row.canceled_at);
        return activeCandidate ? activeCandidate.id : candidates[0].id;
      },
      normalizeRows(rows) {
        if (!Array.isArray(rows)) return [];

        return rows.map((row) => {
          const normalized = { ...row };
          const securedAmount = this.parseNumber(normalized.secured_investment_amount);

          if ((normalized.total_amount === null || normalized.total_amount === undefined || normalized.total_amount === '') && securedAmount !== null) {
            normalized.total_amount = securedAmount;
          }

          if ((!normalized.currency || normalized.currency === '-') && normalized.secured_investment_currency) {
            normalized.currency = normalized.secured_investment_currency;
          }

          return normalized;
        });
      },
      parseNumber(value) {
        if (value === null || value === undefined || value === '') return null;
        const parsed = Number(String(value).replace(',', '.'));
        return Number.isFinite(parsed) ? parsed : null;
      },
      resolveSecuredAmount(tr) {
        const candidates = [tr.total_amount, tr.secured_investment_amount, tr.secured_investment_amount_local];
        for (let i = 0; i < candidates.length; i++) {
          const parsed = this.parseNumber(candidates[i]);
          if (parsed !== null && parsed > 0) {
            return parsed;
          }
        }
        return 0;
      },
      resolveSecuredCurrency(tr) {
        return tr.currency || tr.secured_investment_currency || 'USD';
      },
      isFinalSecuredRow(tr) {
        return this.isFinalTable && tr && tr.is_secured_investment;
      },
      isFinalNonSecuredRow(tr) {
        return this.isFinalTable && !(tr && tr.is_secured_investment);
      },
      canUseFullActionRow() {
        // Action buttons (anular/reemplazar) show for any row with a file, secured or not
        return true;
      },
      isActionDisabled(tr) {
        // Non-secured final rows stay editable as before LATIN-2060; only canceled rows are locked
        return Boolean(tr.canceled_at);
      },
      isSendDisabled(tr) {
        if (tr.canceled_at) {
          return true;
        }

        if (this.isFinalSecuredRow(tr)) {
          return false;
        }

        return Boolean(!tr.is_closed);
      },
      emailButtonLabel(tr) {
        if (this.isFinalSecuredRow(tr) && !tr.is_closed) {
          return 'Cerrar y enviar';
        }

        return !tr.email_send_at ? 'Enviar email' : 'Reenviar email';
      },
      canGenerateSecuredOdc(tr) {
        return this.isFinalSecuredRow(tr) && !tr.id;
      },
      displayCurrency(tr) {
        if (this.isFinalSecuredRow(tr)) {
          return this.resolveSecuredCurrency(tr);
        }

        return tr.currency || '-';
      },
      displayAmount(tr) {
        if (!this.isFinalSecuredRow(tr)) {
          return '-';
        }

        const amount = this.resolveSecuredAmount(tr);
        if (amount <= 0) {
          return '-';
        }

        return this.stringCurrencyFormatter(amount);
      },
      getUniqueCompanyIds() {
        var uniqueIds = [];
        for (var i = 0; i < this.localData.length; i++) {
          var companyId = this.localData[i].company_id;
          if (uniqueIds.indexOf(companyId) === -1) {
            uniqueIds.push(companyId);
          }
        }
        return uniqueIds;
      },
      isCompanySelected(companyId) {
        return this.selectedCompanies.indexOf(companyId) !== -1;
      },
      handleCompanySelection(companyId) {
        this.$emit('toggleCompanySelection', companyId);
      },
      handleSelectAllCompanies() {
        var uniqueCompanyIds = this.getUniqueCompanyIds();
        this.$emit('selectAllCompanies', uniqueCompanyIds);
      },
      openReplaceOdcInput(tr) {
        this.selectedFile = tr;
        document.getElementById(`replaceOdcInput-${tr.id}`).click();
      },
      handleSendEmail(tr) {
        if (this.isFinalSecuredRow(tr)) {
          this.closeAndSendSecuredOdc(tr);
          return;
        }

        this.$vs.notify({
          title: 'Enviando',
          text: 'Enviando email...',
          color: 'dark',
          loading: true,
          duration: 0
        });

        this.$http.post(`${appConfig.apiUrl}/campaigns/${tr.campaign_id}/purchase_orders/${tr.id}`)
        .then(() => {
          this.$vs.notify({
            title: 'Enviado',
            text: 'Email enviado correctamente',
            color: 'success'
          });
          this.$emit('getPurchaseOrderData')
        })
        .catch(error => {
          console.log(error)
          this.$vs.notify({
            title: 'Error',
            text: 'Error al enviar email',
            color: 'danger'
          });
        })
      },
      async generateSecuredOdc(tr) {
        const totalAmount = this.resolveSecuredAmount(tr);

        if (totalAmount <= 0) {
          this.$vs.notify({
            title: 'Error',
            text: 'No se puede generar ODC asegurada sin un monto válido',
            color: 'danger'
          });
          return;
        }

        this.renderLoaderNotify('Generando ODC asegurada...');

        try {
          await this.createSecuredPurchaseOrder(tr);
          this.$vs.notify({
            title: 'Generada',
            text: 'ODC asegurada generada correctamente',
            color: 'success'
          });
          this.$emit('getPurchaseOrderData');
        } catch (error) {
          console.error(error);
          this.$vs.notify({
            title: 'Error',
            text: 'Error al generar ODC asegurada',
            color: 'danger'
          });
        }
      },
      async createSecuredPurchaseOrder(tr) {
        const payload = {
          company_id: tr.company_id,
          total_amount: this.resolveSecuredAmount(tr),
          currency: this.resolveSecuredCurrency(tr)
        };

        let response = null;

        try {
          response = await this.$http.post(
            `${appConfig.apiUrl}/campaigns/${tr.campaign_id}/purchase_orders/secure`,
            payload
          );
        } catch (error) {
          const status = this.extractErrorStatus(error);
          const existingPurchaseOrderId = this.extractPurchaseOrderIdFromError(error);

          if (status !== 409 || !existingPurchaseOrderId) {
            throw error;
          }

          return {
            id: existingPurchaseOrderId,
            purchase_order_id: existingPurchaseOrderId,
            reused_existing: true
          };
        }

        const responseData = response && response.data ? response.data : {};
        const purchaseOrder = responseData.data || responseData.purchase_order || responseData;
        return purchaseOrder;
      },
      extractPurchaseOrderId(purchaseOrder) {
        if (!purchaseOrder) return null;
        return purchaseOrder.id || purchaseOrder.purchase_order_id || null;
      },
      async closeAndSendSecuredOdc(tr) {
        const totalAmount = this.resolveSecuredAmount(tr);

        if (totalAmount <= 0) {
          this.$vs.notify({
            title: 'Error',
            text: 'No se puede cerrar y enviar sin un monto válido',
            color: 'danger'
          });
          return;
        }

        this.renderLoaderNotify('Cerrando y enviando ODC asegurada...');

        try {
          let purchaseOrderId = tr.id;

          if (!purchaseOrderId) {
            purchaseOrderId = this.findExistingSecuredPurchaseOrderId(tr);
          }

          if (!purchaseOrderId) {
            const purchaseOrder = await this.createSecuredPurchaseOrder(tr);
            purchaseOrderId = this.extractPurchaseOrderId(purchaseOrder);
          }

          if (!purchaseOrderId) {
            throw new Error('No se pudo obtener el id de la ODC asegurada');
          }

          await this.$http.post(
            `${appConfig.apiUrl}/campaigns/${tr.campaign_id}/purchase_orders/${purchaseOrderId}/close-and-send`,
            {
              total_amount: totalAmount,
              currency: this.resolveSecuredCurrency(tr)
            }
          );

          this.$vs.notify({
            title: 'Enviada',
            text: 'ODC asegurada cerrada y enviada correctamente',
            color: 'success'
          });
          this.$emit('getPurchaseOrderData');
        } catch (error) {
          console.error(error);
          this.$vs.notify({
            title: 'Error',
            text: 'Error al cerrar y enviar ODC asegurada',
            color: 'danger'
          });
        }
      },
      async closeOdc(data) {
        const rest = { ...data };
        delete rest.file;

        this.renderLoaderNotify('Cerrando orden de compra...')

        const newData = {
          ...rest,
          is_closed: 1,
        }

        await this.updateOdc(data.id, newData)
      },
      async replaceOdc(data) {
        this.renderLoaderNotify('Actualizando archivo...')
        await this.updateOdc(data.id, data)
      },
      async toggleCancelOdc(data) {
        const rest = { ...data };
        delete rest.file;

        this.renderLoaderNotify('Actualizando archivo...')

        const newData = {
          ...rest,
          canceled_at: data.canceled_at ? null : new Date()
        }

        await this.updateOdc(data.id, newData)
      },
      async handleCurrencyEdit(id, value) {
        const original = this.localData.find(item => item.id === id);
        const rest = { ...original };
        delete rest.file;

        this.renderLoaderNotify('Actualizando moneda...')

        const data = {
          ...rest,
          currency: value
        }

        await this.updateOdc(data.id, data)
      },
      handleTotalAmountEdit: _.debounce(async function(id, value) {
        const original = this.localData.find(item => item.id === id);
        const rest = { ...original };
        delete rest.file;

        const numericValue = this.parseAmount(value);

        // Validate if value is a valid money number
        if (isNaN(numericValue) || numericValue < 0) {
          this.$vs.notify({
            title: 'Error',
            text: 'El monto debe ser un número válido mayor o igual a 0',
            color: 'danger'
          });
          return;
        }

        this.renderLoaderNotify('Actualizando monto...')

        const data = {
          ...rest,
          total_amount: numericValue
        }

        await this.updateOdc(data.id, data)
      }, 300),
      async updatePaidAt(id, date) {
        const original = this.localData.find(item => item.id === id);
        const rest = { ...original };
        delete rest.file;

        const oldDate = new Date(rest.payment_date).toISOString()
        const newDate = new Date(date[0]).toISOString()

        // Convert dates to same format for comparison
        const oldDateFormatted = oldDate.split('T')[0];
        const newDateFormatted = newDate.split('T')[0];

        // If dates are the same, return early
        if (oldDateFormatted === newDateFormatted) {
          return;
        }

        this.renderLoaderNotify('Actualizando fecha de pago...')

        const newData = {
          ...rest,
          payment_date: newDate
        }

        await this.updateOdc(id, newData)
      },
      handleReplaceOdcUpload(event) {
        const file = event.target.files[0];
        if (!file) return;

        if (file.type !== 'application/pdf' || file.size > 2048 * 1000) {
          this.$vs.notify({
              title: 'Error',
              text: 'Solo se permiten archivos PDF menores a 2MB',
              color: 'danger'
          });
          event.target.value = ''; // Reset input
          return;
        }

        this.replaceOdc({
          ...this.selectedFile,
          file: file
        })
      },
      async updateOdc(id, data) {
        const formData = new FormData();

        formData.append('year', data.year);
        formData.append('month', Number(data.month));
        formData.append('total', this.parseAmount(data.total_amount));
        formData.append('currency', data.currency);
        formData.append('is_invoiced', Number(Boolean(data.invoiced_at)));
        formData.append('is_paid', Number(Boolean(data.paid_at)));

        formData.append('is_canceled', Number(Boolean(data.canceled_at)));
        formData.append('is_closed', data.is_closed);

        if (data.payment_date) {
          formData.append('payment_date', data.payment_date);
        }
        if (data.file) {
          formData.append('file', data.file);
        }

        return this.$http.post(`${appConfig.apiUrl}/purchase-orders/${id}`, formData)
          .then(() => {
            this.$vs.notify({
              title: 'Actualizada',
              text: 'ODC actualizada correctamente',
              color: 'success'
            });
            this.$emit('getPurchaseOrderData')
          })
          .catch((error) => {
            console.error(error);
            this.$vs.notify({
              title: 'Error',
              text: error.message,
              color: 'danger'
            });
            throw error;
          });
      },
      renderLoaderNotify(text) {
        this.$vs.notify({
          title: 'Actualizando',
          text: text,
          color: 'dark',
          loading: true,
          duration: 0
        })
      }
    }
}
</script>
